<div class="custom-toast-wrapper" *ngIf="toastList?.length">
  <div
    *ngFor="let toast of toastList; let i = index"
    @verticalCollapse
    @triggerChildAnimation
    @verticalExpand
  >
    <div
      class="toast-item row m-0 mb-2 {{ toast?.type || toast?.status }}"
      [@slideIn]="toast?.show"
      [@slideOut]="!toast?.show"
    >
      <!-- Icon -->
      <div class="col-1 p-0">
        <nb-icon
          [icon]="toast?.icon"
          pack="fci"
          class="toast-icon float-left"
        ></nb-icon>
      </div>

      <!-- Content -->
      <div class="col-10 p-0">
        <div class="d-flex flex-column">
          <!-- Title -->
          <p class="weight-500 mb-1" style="font-size: 0.875rem">
            {{ toast?.title }}
          </p>
          <!-- Content -->
          <p [innerHtml]="toast?.content" class="mb-0"></p>
          <!-- Link @deprecated-->
          <div *ngIf="toast?.link" class="mb-1 mt-2">
            <a
              [href]="toast?.link?.url"
              [routerLink]="toast?.link?.routerLink"
              [nbTooltip]="toast?.link?.tooltip"
              [nbTooltipDisabled]="!toast?.link?.tooltip"
              (click)="onLinkClick(toast, i)"
              class="d-flex align-items-center cursor-pointer"
              [ngStyle]="{
                'text-decoration': toast?.link?.url ? '' : 'none',
                'pointer-events': toast?.link?.disabled ? 'none' : ''
              }"
            >
              <span>{{ toast?.link?.label }}</span>
              <nb-icon [icon]="toast?.link?.icon"></nb-icon>
            </a>
          </div>

          <!-- Links -->
          <div
            *ngIf="toast?.links"
            class="mt-2 mb-2"
            style="display: flex; flex-wrap: wrap"
          >
            <ng-container *ngFor="let link of toast?.links">
              <a
                [href]="link?.url"
                [routerLink]="link?.routerLink"
                [nbTooltip]="link?.tooltip"
                [nbTooltipDisabled]="!link?.tooltip"
                (click)="onToastActionClick(link, i)"
                class="d-flex justify-content-start align-items-center cursor-pointer mr-3 mb-1"
                [ngStyle]="{
                  'text-decoration': link?.url ? '' : 'none',
                  'pointer-events': link?.disabled ? 'none' : ''
                }"
              >
                <span>{{ link?.label }}</span>
                <nb-icon [icon]="link?.icon" *ngIf="link?.icon"></nb-icon>
              </a>
            </ng-container>
          </div>

          <!-- Buttons -->
          <div
            *ngIf="toast?.buttons"
            style="display: flex; flex-wrap: wrap"
            class="mt-2"
          >
            <ng-container *ngFor="let button of toast?.buttons">
              <app-rbac-button
                [id]="button?.id"
                [label]="button?.label"
                [status]="button?.status || 'basic'"
                [appearance]="button?.appearance || 'filled'"
                [toolTip]="button?.tooltip"
                [icon]="button?.icon"
                [isFciPack]="button?.iconPack === 'fci'"
                [class]="button?.class"
                [action]="button?.action"
                [loading]="button?.loading"
                [disabled]="button?.disabled"
                (onClick)="onToastActionClick(button, i)"
                class="mr-3 mb-1"
              ></app-rbac-button>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Close -->
      <div class="col-1 p-0">
        <nb-icon
          icon="close-outline"
          pack="fci"
          (click)="onClose(i)"
          class="float-right cursor-pointer"
        ></nb-icon>
      </div>
    </div>
  </div>
</div>
